import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { GoalsPageFilter } from './GoalsPageFilter';
import { getGoalEntriesStatuses } from '../../../../selectors';
import { getLocales, getAccess } from './GoalsPageFilter.selectors';
import { I18nContext } from 'utils/I18n/context';

const mapStateToPropsSelectors = createStructuredSelector({
    locales: getLocales,
    access: getAccess,
    statuses: getGoalEntriesStatuses
});

const Connected = connect(
    function mapStateToProps(state) {
        return { ...mapStateToPropsSelectors(state) };
    },
    function mapDispatchToProps() {
        return {};
    }
)(GoalsPageFilter);

export default function GoalsPageFilterContainer(props) {
    const loc = useLocation();
    const { t } = useContext(I18nContext);
    
    return (
        <Connected
            {...props}
            t={t}
            location={{ pathname: loc.pathname, query: loc.search }}
        />
    );
}
